/**
 * Environment variable used to launch the app with mockData
 */
const { REACT_APP_ENV } = process.env;

export default REACT_APP_ENV;
